import { render, staticRenderFns } from "./SenhaPoliticas.vue?vue&type=template&id=482e74be&scoped=true"
import script from "./SenhaPoliticas.vue?vue&type=script&lang=js"
export * from "./SenhaPoliticas.vue?vue&type=script&lang=js"
import style0 from "./SenhaPoliticas.vue?vue&type=style&index=0&id=482e74be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e74be",
  null
  
)

export default component.exports